import React, { useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { SearchInput } from '../SearchInput';
import styles from './SearchBar.module.scss';

export const SearchBar = ({ 
    onSearch, 
    placeholder = "Search by queue number...",
    className = "" 
}) => {
    const [searchValue, setSearchValue] = useState("");

    const handleSearchChange = useCallback((value) => {
        setSearchValue(value);
        if (onSearch) {
            onSearch(value);
        }
    }, [onSearch]);

    const handleClear = useCallback(() => {
        setSearchValue("");
        if (onSearch) {
            onSearch("");
        }
    }, [onSearch]);

    return (
        <div className={`${styles['search-bar']} ${className}`}>
            <Container fluid>
                <Row className="justify-content-center">
                    <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                        <div className={styles['search-bar-content']}>
                            <SearchInput
                                value={searchValue}
                                onChange={handleSearchChange}
                                onClear={handleClear}
                                placeholder={placeholder}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
